import { Component, OnInit } from '@angular/core';
import { QARService, SORUserEntity, SystemLoaderUserBlacklistEntity } from '../services/qar.service';
import { Chunker } from '../framework/chunker';


@Component({
	selector: 'app-page-blacklist',
	templateUrl: './blacklist.html',
	providers: [QARService]
})
export class BlacklistPageComponent implements OnInit {

	constructor(public api: QARService) {
	}

	ngOnInit() {
		this.blacklist_init();
	}

	public blacklist = {
		loading: true,
		chunker: new Chunker([]),
		chunkedData: [],
		systems: [],
		selected: new SystemLoaderUserBlacklistEntity(),

	};

	blacklist_init() {
		this.newBlacklist.data = new SystemLoaderUserBlacklistEntity();
		this.blacklist.loading = true;
		this.api.retrieveBlacklist().then(r => {
			this.blacklist.loading = false;
			this.blacklist.chunker = new Chunker(r);
		}, e => {
			alert('Sorry, please try again');
			this.blacklist.loading = false;
		});

		this.api.retrieveSystems().then(r => {
			this.blacklist.systems = r;
		})
	}

	public blacklist_idSystemName(r: SystemLoaderUserBlacklistEntity) {
		return r.SystemLoader.System.Name;
	}

	public blacklist_idSystemLoaderName(r: SystemLoaderUserBlacklistEntity) {
		return r.SystemLoader.Name;
	}

	public blacklist_delete(entry: SystemLoaderUserBlacklistEntity) {
		if (confirm('Delete ' + entry.UserName + " / " + entry.RoleName + " on system " + entry.SystemLoader.System.Name + " " + entry.SystemLoader.Name + " loader?")) {
			this.api.deleteBlacklist(entry.Id).then(r => {
				this.blacklist_init();
			})
		}
	}

	public newBlacklist = {
		data: new SystemLoaderUserBlacklistEntity(),
		saving: false,
		nullRole: false,
	}


	public newBlacklist_save() {
		if (!this.newBlacklist.data.SystemLoaderId)
			return alert('Please select a "System Loader"');
		if (!this.newBlacklist.data.UserName)
			return alert('Please enter a "Local User Alias"');
		if (!this.newBlacklist.data.RoleName && !this.newBlacklist.nullRole)
			return alert('Please enter a "Role Name"');
		if (!this.newBlacklist.data.Reason)
			return alert('Please enter a "Reason"');

		this.api.saveBlacklist(this.newBlacklist.data, this.newBlacklist.nullRole).then(r => {
			this.newBlacklist.saving = false;
			this.blacklist_init();
			this.newBlacklist.data = new SystemLoaderUserBlacklistEntity();
			this.newBlacklist.nullRole = false;
		}, e => {
			this.newBlacklist.saving = false;
			alert('Sorry, something went wrong, please try again');
		});
	}
}
